"use strict";
// Auth capability + its sign-in providers.
//
// `auth` owns the session (provides `auth.session@1`) and declares
// `auth.provider@1`. Email/password and Google are providers of it. Their
// tiles are the legacy Integrations-panel entries, so `INTEGRATIONS` is
// derived from these manifests unchanged.
Object.defineProperty(exports, "__esModule", { value: true });
exports.GOOGLE_AUTH_PLUGIN = exports.EMAIL_PASSWORD_AUTH_PLUGIN = exports.AUTH_PLUGIN = void 0;
exports.AUTH_PLUGIN = {
    id: 'auth',
    version: '1.0.0',
    kind: 'capability',
    trust: 'first-party',
    title: 'Accounts',
    description: 'Sign up, sign in, sessions and protected pages for the people who use your app.',
    icon: 'i-ph:user-circle',
    surfaces: ['web-app'],
    agentCard: 'Accounts: sign up/in/out, sessions, protected pages, per-user data (skills/auth.md).',
    declares: {
        'auth.provider': {
            major: 1,
            cardinality: 'many',
            description: 'A way to sign in (email + password, Google, magic link…).',
            features: ['password', 'oauth', 'brokered', 'byoCredentials'],
        },
        'auth.session': {
            major: 1,
            cardinality: 'one',
            description: 'Read the signed-in user. Other plugins use this for customer accounts.',
        },
    },
    provides: {
        'auth.session': { major: 1 },
    },
    emits: {
        'auth.user.created': { major: 1, description: 'A new account was created.' },
    },
    targets: {
        'web-app': {
            skills: ['auth'],
            lockedPaths: ['frontend/worker/dunea/auth.ts', 'frontend/src/dunea/auth.tsx'],
        },
    },
};
exports.EMAIL_PASSWORD_AUTH_PLUGIN = {
    id: 'email-password-auth',
    version: '1.0.0',
    kind: 'provider',
    trust: 'first-party',
    title: 'Email & Password',
    description: 'Classic email + password accounts — sign up, sign in, protected pages. No configuration needed.',
    surfaces: ['web-app'],
    provides: {
        'auth.provider': { major: 1, features: { password: true } },
    },
    targets: {
        'web-app': { detect: ['registerAuthRoutes'] },
    },
    tile: {
        category: 'auth',
        icon: 'i-ph:envelope-simple',
        invokePrompt: 'Add email and password authentication (sign up, sign in, sign out, and a protected area) using the auth library.',
        skill: 'auth',
        credentials: { mode: 'shared', fields: [] },
    },
};
exports.GOOGLE_AUTH_PLUGIN = {
    id: 'google-auth',
    version: '1.0.0',
    kind: 'provider',
    trust: 'first-party',
    title: 'Google Sign-In',
    description: 'Let users sign in with Google. Works out of the box; add your own Google app to show your brand on the consent screen.',
    surfaces: ['web-app'],
    provides: {
        'auth.provider': { major: 1, features: { oauth: true, brokered: true, byoCredentials: true } },
    },
    targets: {
        'web-app': { detect: ['loginWithGoogle'] },
    },
    tile: {
        category: 'auth',
        icon: 'i-ph:google-logo',
        invokePrompt: 'Add "Continue with Google" sign-in to the login screen using the auth library.',
        skill: 'auth',
        broker: 'google',
        credentials: {
            mode: 'byo-optional',
            redirectUri: 'https://auth.dunea.app/google/callback',
            fields: [
                {
                    key: 'clientId',
                    label: 'Google Client ID',
                    secret: false,
                    help: 'From Google Cloud Console → Credentials → your OAuth 2.0 Web client.',
                    placeholder: '1234567890-abc.apps.googleusercontent.com',
                },
                {
                    key: 'clientSecret',
                    label: 'Google Client Secret',
                    secret: true,
                    help: 'The client secret for that same OAuth client. Stored encrypted.',
                },
            ],
        },
    },
};
